// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

const SwiperGalleries = function () {

    //galeria webdoor
    const gallerySwiperWebdoor = () => {
        // init Swiper:
        const swiper = new Swiper('.swiperFull', {
            speed       : 2000,
            loop        : true,
            effect      : 'slide',
            autoplay    : {
                delay: 5000,
                disableOnInteraction: false,
              },
            pagination  : {
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                  return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
              },
        });
    }

    //galeria apartamentos 
    const galleryAptos = () => {
        
        const galAptos = "#swiper-apartments";
        if($(galAptos).length <= 0) return;

        let perView = 4;
        let totSliders = $(galAptos).find('.swiper-slide').length;

        console.log(`total = ${totSliders}`, `exibindo = ${perView}`);

        // esconde navegação
        if(totSliders <= perView){
            if($(window).width() > 992){
                $("#swiper-horiz-button-prev").parent().hide();
            }
        }
        
        // if(totSliders < (perView + 2)){
        if(totSliders < 5){
            if($(window).width() > 992){
                $(galAptos).addClass('noMinim');
                $(galAptos).find('.swiper-wrapper').css({display : 'flex', justifyContent : 'center'})
                $(galAptos).find('.swiper-slide').last().css({marginRight : '0px'})
            }
        }

        const swiperHoriz = new Swiper(galAptos, {
            // cssMode     : true,
            speed:1000,
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            paginationClickable: true,
            spaceBetween: 20,
            slideToClickedSlide: false,

              navigation: {
                  prevEl: "#swiper-horiz-button-prev",
                  nextEl: "#swiper-horiz-button-next",
              },
              breakpoints: {
                992: {
                    slidesPerView: perView,
                    centeredSlides: totSliders >= (perView + 2) ? true : false,
                    loop: totSliders >= (perView + 2) ? true : false,
                    spaceBetween: 40,
                },
            }
        });

    }
    //galeria basica (onde quiser)
    const galleryBasicSwiper = () => {

        const galBasic = document.querySelectorAll('.swiper-basic');

        if(!galBasic) return;

        for( let i=0; i< galBasic.length; i++ ) {
  
            galBasic[i].classList.add('swiper-container-swiper-basic-' + i);
            $(galBasic).eq(i).find('.swiper-pagination').addClass('galPagination-'+i);
            $(galBasic).eq(i).closest('.row-gallery').find('.swiper-arrow-left').addClass('swiper-arrow-left-'+i)
            $(galBasic).eq(i).closest('.row-gallery').find('.swiper-arrow-right').addClass('swiper-arrow-right-'+i)

            const swiperHL = new Swiper('.swiper-container-swiper-basic-' + i, {
                speed           : 1000,
                loop            : true,
                effect          : 'coverflow',
                autoplay        : false,
                // autoplay        : {
                //     delay: 5000,
                //     disableOnInteraction: false,
                // },
                grabCursor: true,
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: ["-20%", 0, -1],
                      },
                    next: {
                        translate: ["100%", 0, 0],
                    },
                },
                navigation: {
                    nextEl: ".swiper-arrow-right-"+i,
                    prevEl: ".swiper-arrow-left-"+i,
                },
                pagination  : {
                    el: '.galPagination-'+i,
                    clickable: true,
                    // renderBullet: function (index, className) {
                    // return '<span class="' + className + '">' + (index + 1) + "</span>";
                    // },
                },
            });

        }

    }


    return {

        // gallerySwiperWebdoor    : gallerySwiperWebdoor,
        // galleryBasicSwiper      : galleryBasicSwiper,

        init : () => {
            galleryAptos();
            galleryBasicSwiper();
        }

        
        
    }

}();

export default SwiperGalleries;